import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'numOfDays',
    standalone: true
})
export class NumOfDaysPipe implements PipeTransform {

    transform(start: string, end: string): number {
        const startDate = new Date(start);
        const endDate = new Date(end);
        if (startDate && endDate && (startDate <= endDate)) {
            const timeDiff = endDate.getTime() - startDate.getTime();
            return Math.ceil(timeDiff / (1000 * 3600 * 24));
        } else {
            return 0;
        }
    }

}
